import React, { PropTypes } from "react";
import { connect } from "react-redux";
import { Field, getFormValues, reduxForm } from "redux-form";
import { FormattedMessage } from "react-intl";
import HTML5Backend from "react-dnd-html5-backend";
import { DragDropContext } from "react-dnd";

import { BlocClientsContainer } from "./";
import validationUtils from "../../../../../../utils/ValidationUtils";
import { BLOC_CLIENTS_VALIDATION_RULES } from "./blocClientsValidationRules";
import { TextInput } from "../../../../../common/form";

class BlocClientsFields extends React.Component {
  render() {
    const { formValues, blocId, handleSubmit } = this.props;
    if (!formValues) {
      return null;
    }
    const splits = formValues.splits || [];
    return (
      <form onSubmit={handleSubmit}>
        <Field
          id="name"
          name="name"
          component={TextInput}
          type="text"
          required={true}
          label={<FormattedMessage id="admin.blocs.form.name" />}
        />

        <div className="guarantees bloc-clients">
          <div className="sub-group">
            <h3>
              <FormattedMessage id="admin.blocs.bloc.clients.form.assigned" />
            </h3>
            <div className="fiscal-split">
              <div className="fiscal-split-row in-split">
                <div className="content">
                  <BlocClientsContainer
                    formValues={this.props.formValues}
                    disabled={this.props.disabled}
                    id="assigned"
                    blocId={blocId}
                    list={splits.filter(
                      (client) => client.blocId === parseInt(blocId)
                    )}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="sub-group">
            <h3>
              <FormattedMessage id="admin.blocs.bloc.clients.form.unassigned" />
            </h3>
            <div className="fiscal-split">
              <div className="fiscal-split-row">
                <div className="content">
                  <BlocClientsContainer
                    formValues={this.props.formValues}
                    disabled={this.props.disabled}
                    id="unassigned"
                    blocId={null}
                    list={splits.filter((client) => !client.blocId)}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    );
  }
}

BlocClientsFields.propTypes = {
  disabled: PropTypes.bool,
  error: PropTypes.object,
  formValues: PropTypes.object,
  blocId: PropTypes.string,
  handleSubmit: PropTypes.func,
};

function mapStateToProps(state) {
  return {
    formValues: getFormValues("blocClients")(state),
  };
}

export default connect(mapStateToProps, null, null, { withRef: true })(
  reduxForm({
    form: "blocClients",
    validate: (values) =>
      validationUtils.validate(values, BLOC_CLIENTS_VALIDATION_RULES),
  })(DragDropContext(HTML5Backend)(BlocClientsFields))
);



// WEBPACK FOOTER //
// ./src/components/dashboard/admin/blocs/bloc/clients/BlocClientsFields.js